import React from 'react';
import { Regular } from '@worthy-npm/clarity'
import { imageUrl } from 'helpers/ApplicationHelper';

const PageIntro = (props) => {
    return (
        <div className="learn-page-intro d-flex flex-align-center">
            <div className="intro-icon">
                <img alt={props.pic.alt} src={imageUrl(props.pic.url)}/>
            </div>
            <div className="intro-text">
                <Regular text={props.text}/> 
            </div>
        </div>
    );
}

export default PageIntro;